import Big from "big.js";

export const parseBig = (value: Big, dp = 2) => parseFloat(value.toFixed(dp));
export const getMinBigJs = (a: Big, b: Big) => (a.lt(b) ? a : b);
export const toCentsBig = (value: number) =>
  !value ? new Big(0) : new Big(value.toString()).times(100);
